import { useMemo } from 'react';
import Head from 'next/head';
import { getRuntimeConfig } from '~/shared/utils/config';
import { usePDPData } from '~/features/product-details/context';

export const ProductMetafields: React.FC = () => {
    const { config } = getRuntimeConfig();
    const { product } = usePDPData();

    const {
        c_pageURL,
        c_canonical,
        pageTitle,
        pageDescription,
        shortDescription,
        pageKeywords,
        id,
    } = product;

    // Generate canonical and OG URLs
    const canonicalUrl = useMemo(() => {
        return new URL(c_pageURL || c_canonical || '/', config.NEXT_PUBLIC_URL).toString();
    }, [c_pageURL, c_canonical, id]);

    const ogUrl = useMemo(() => {
        return new URL(c_pageURL || '/', config.NEXT_PUBLIC_URL).toString();
    }, [c_pageURL, id]);

    // Description for meta tags
    const metaDescription = pageDescription || shortDescription || null;

    return (
        <Head>
            {/* Title tags */}
            {pageTitle && (
                <>
                    <title key="title">{pageTitle}</title>
                    <meta key="metaName" name="name" content={pageTitle} />
                </>
            )}

            {/* Description */}
            {metaDescription && (
                <meta key="description" name="description" content={metaDescription} />
            )}

            {/* Keywords */}
            {pageKeywords && <meta key="keywords" name="keywords" content={pageKeywords} />}

            {/* Canonical URL */}
            {canonicalUrl && <link key="canonical" rel="canonical" href={canonicalUrl} />}

            {/* OpenGraph tags */}
            {ogUrl && <meta key="ogUrl" property="og:url" content={ogUrl} />}
            {pageTitle && <meta key="ogTitle" property="og:title" content={pageTitle} />}
            {metaDescription && (
                <meta key="ogDescription" property="og:description" content={metaDescription} />
            )}

            {/* Product type */}
            <meta key="ogType" property="og:type" content="product" />
        </Head>
    );
};
